import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";
import dayjs from "dayjs";

export const scheduledList = createAsyncThunk('scheduledList', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `schedule_maintenance`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'department_id': data?.department_id,
                'maintainace_date': data?.maintenance_date ? dayjs(data?.maintenance_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : '',
                'job_card_number': data?.job_card_number,
                'make_id': data?.make_id,
                'part_number': data?.part_number,
                'location_id': data?.location_id,
                'component_id': data?.component_id,
                'equipment_id': data?.equipment_id,
                'ticket_status': data?.status,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const scheduledListSlice = createSlice({
    name: 'scheduledList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(scheduledList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = [];
            }

        });
        builder.addCase(scheduledList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default scheduledListSlice.reducer;